import { Button, Dialog } from '@mui/material'
import { useState } from 'react'
import { makeBookingInDayViewCalendar } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingComponents'
import HoldSlotAndSendLinkOptions from 'src/clinic/components/ClinicManageBookingsPage/newBookingCalendar/HoldSlotAndSendLinkOptions'

export default function HoldSlotAndSendLInkToPayButton({
  askPayment,
  paymentDetail,
  forMentor,
  clinicId,
  clinicBrandId,
  mentorProfileData,
  clickedWantedSlotData,
  eventDataForSelectedEventType,
  selectedPatient,
  updateBookingsInCalendar,
  setNewBookingDialogOpen,
  setBookingLoading,
  setSelectedPatient,
  setIsNewPatient,
  setNewPatientInputData,
  chosenChamberRoomId,
  tryBookingScreening,
  selectedRelatedConsultationForTherapy,
  meetingBookApiSignature,
  relativeInformation,
  customFunctionForHoldSlotAndSendLinkToPay,
  bookingLoading,
  forceDisable = false,
}) {
  const [showHoldSlotAndSendLinkOptions, setShowHoldSlotAndSendLinkOptions] = useState(false)

  function holdSlotAndSendLinkToPay({
    sendLinkToPatient = false,
    sendLinkToRelative = false,
    customPhonesToSendLinkTo = [],
  }) {
    if (customFunctionForHoldSlotAndSendLinkToPay) {
      customFunctionForHoldSlotAndSendLinkToPay({
        sendLinkToPatient,
        sendLinkToRelative,
        customPhonesToSendLinkTo,
      })
      setShowHoldSlotAndSendLinkOptions(false)
      return
    }

    makeBookingInDayViewCalendar(
      forMentor,
      clinicId,
      clinicBrandId,
      mentorProfileData?.id,
      askPayment,
      clickedWantedSlotData,
      eventDataForSelectedEventType,
      selectedPatient,
      updateBookingsInCalendar,
      setNewBookingDialogOpen,
      {
        feePaid: paymentDetail?.feePaid,
        feePaymentMode: 'aumhum',
        feePaidTxnId: paymentDetail?.feePaidTxnId,
        currency: paymentDetail?.currency,
      },
      setBookingLoading,
      setSelectedPatient,
      setIsNewPatient,
      setNewPatientInputData,
      chosenChamberRoomId,
      tryBookingScreening,
      true,
      null,
      null,
      selectedRelatedConsultationForTherapy,
      meetingBookApiSignature,
      undefined,
      sendLinkToPatient,
      sendLinkToRelative,
      customPhonesToSendLinkTo,
    )
  }

  return (
    <>
      <Button
        sx={{
          width: '100%',
          minHeight: '48px',
          fontSize: '16px',
          marginBottom: '8px',
          '@media (min-width: 600px)': {
            width: 'auto',
            minWidth: '200px',
          },
        }}
        variant="outlined"
        disabled={(() => {
          if (forceDisable) {
            return true
          }
          if (bookingLoading) {
            return true
          }
          if (askPayment) {
            if (paymentDetail?.feePaid && paymentDetail?.feePaymentMode) {
              if (paymentDetail?.feePaymentMode === 'cash') {
                return false
              } else if (paymentDetail?.feePaymentMode !== 'cash') {
                return false
              } else {
                return true
              }
            } else {
              return true
            }
          } else {
            return false
          }
        })()}
        onClick={() => {
          setShowHoldSlotAndSendLinkOptions(true)
        }}
      >
        {bookingLoading ? 'Booking...' : 'Hold Slot & send Link to Pay'}
      </Button>
      <Dialog
        open={showHoldSlotAndSendLinkOptions}
        onClose={() => {
          setShowHoldSlotAndSendLinkOptions(false)
        }}
        // The parent booking dialog (CMBCBootstrapDialog) is bumped to zIndex 1600 to sit above
        // the check-in chrome. This nested Dialog renders at the default modal zIndex (1300), so
        // without this lift it opens *behind* the booking dialog and clicking the button looks
        // like nothing happens. Lift it above the parent (mirrors the Select MenuProps fix in
        // NewBookingDialogComponent).
        sx={{ zIndex: 1700 }}
      >
        <HoldSlotAndSendLinkOptions
          holdSlotAndSendLinkToPay={holdSlotAndSendLinkToPay}
          setShowHoldSlotAndSendLinkOptions={setShowHoldSlotAndSendLinkOptions}
          relativeInformation={relativeInformation}
          bookingLoading={bookingLoading}
        />
      </Dialog>
    </>
  )
}
